import { devices } from '@helpers/utils.js';

const BackgroundTypeImageSave = ({
  backgroundImageOptions,
  blockId,
  defaultBlockCssClass,
  printBackgroundStyles,
}) => {
  return (
    <style>
      {devices.map((device) => {
        const deviceType = device.type;
        const backgroundImageSettings =
          backgroundImageOptions[deviceType]?.settings || {};
        const { sectionImgUrl = '' } = backgroundImageSettings;

        let cssCode = '';
        const printQuery = printBackgroundStyles
          ? `, print and (max-width: ${backgroundImageOptions[deviceType].breakpoint}px)`
          : ``;

        if (sectionImgUrl) {
          const imageSetAttribute = `url(${sectionImgUrl})`;

          cssCode = `@media only screen and (max-width: ${
            backgroundImageOptions[deviceType]?.breakpoint || 0
          }px)${printQuery} {
              .${defaultBlockCssClass}.${defaultBlockCssClass}-${blockId} {
                background-image: url(${sectionImgUrl});
                background-image: -webkit-image-set(${imageSetAttribute});
                background-image: image-set(${imageSetAttribute});
                background-position: center center;
                background-size: cover;
              }
            }`;
        }

        return cssCode;
      })}
    </style>
  );
};

export default BackgroundTypeImageSave;
